// Meta information about the languages and locale files
//
// When adding new languages, don't forget to check the
// webpack/adjustments.js languageRegexes

import localeDa from 'air-datepicker/locale/da';
import localeDe from 'air-datepicker/locale/de';
import localeEn from 'air-datepicker/locale/en';
import localeEs from 'air-datepicker/locale/es';
import localeFr from 'air-datepicker/locale/fr';
import localeIt from 'air-datepicker/locale/it';
import localeNl from 'air-datepicker/locale/nl';
import localePl from 'air-datepicker/locale/pl';
import localePt from 'air-datepicker/locale/pt';
import localeRu from 'air-datepicker/locale/ru';
import localeSv from 'air-datepicker/locale/sv';
import localeTr from 'air-datepicker/locale/tr';
import localeUk from 'air-datepicker/locale/uk';
import localeZh from 'air-datepicker/locale/zh';
import localeCs from 'air-datepicker/locale/cs';
import localeRo from 'air-datepicker/locale/ro';

/** @typedef {{code: string, label: string, momentJsLocale: ?string, datepickerLocale: string }} LocaleDef */

export const localeMeta = {
    main: 'en',
    /** @type {LocaleDef[]} */
    languages: [
        {code:'de', label: 'Deutsch', datepickerLocale: localeDe},
        {code:'da', label: 'Dansk', datepickerLocale: localeDa},
        {code:'en', label: 'English', datepickerLocale: localeEn},
        {code:'nl', label: 'Nederlands', datepickerLocale: localeNl },
        {code:'es', label: 'Español', datepickerLocale: localeEs },
        {code:'fr', label: 'Français', datepickerLocale: localeFr },
        {code:'it', label: 'Italiano', datepickerLocale: localeIt },
        {code:'pt', label: 'Português', datepickerLocale: localePt },
        {code:'sv', label: 'Svenska', datepickerLocale: localeSv },
        {code:'ru', label: 'Русский', datepickerLocale: localeRu },
        {code:'zh', label: '中文', momentJsLocale: 'zh-cn', datepickerLocale: localeZh },
        {code:'tr', label: 'Türk', datepickerLocale: localeTr },
        {code:'uk', label: 'Українська', datepickerLocale: localeUk },
        {code:'pl', label: 'Polski', datepickerLocale: localePl },
        {code:'cs', label: 'Čeština', datepickerLocale: localeCs },
        {code:'ro', label: 'Română', datepickerLocale: localeRo }
    ],
    /**
     * @returns {LocaleDef|null}
     */
    getByCode(code) {
        return this.languages.find(lang => lang.code === code);
    },
    /**
     * @param {string} code
     * @returns {string}
     */
    getMomentJsLocale(code) {
        const meta = this.getByCode(code);
        const result = (meta && meta.momentJsLocale) ? meta.momentJsLocale : code;
        return result;
    },
    /**
     * @returns {LocaleDef[]}
     */
    languagesMainFirst() {
        return this.languages.slice().sort((a, b) => {
            if (a.code === this.main) return -1;
            if (b.code === this.main) return 1;
            return a.code.localeCompare(b.code);
        });
    },
};
